import { render, staticRenderFns } from "./ClientAccount.vue?vue&type=template&id=0e568130"
import script from "./ClientAccount.vue?vue&type=script&lang=js"
export * from "./ClientAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports